import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col, ListGroup, Image, Card, Container } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { FaTruck, FaCreditCard, FaUniversity, FaUser, FaMapMarkerAlt, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import Message from '../components/Message';
import CheckoutStatusBar from '../components/CheckoutStatusBar.jsx';
import CheckoutStatusBar1 from '../components/CheckoutStatusBar1.jsx';
import Loader from '../components/Loader';
import { useCreateOrderMutation, useGetCurrencyQuery } from '../slices/ordersApiSlice';
import accounting from 'accounting-js';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import DocumentModal from '../components/DocumentModal.jsx';
// NOT: `crypto-js` importu kaldırıldı. HashData hesaplama ve API şifresi
// artık SADECE backend'de (orderController.js) yer alıyor - bkz. fetchData.

const PlaceOrderScreen = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const cart = useSelector((state) => state.cart);
  const [trig, setTrig] = useState('');
  const { data: currency } = useGetCurrencyQuery();
  const [createOrder, { isLoading, error }] = useCreateOrderMutation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [isEnable, setIsEnable] = useState(false);

  // Bankaya güvenli 3D Secure formu göndermek için kullanılan gizli form referansları.
  // Gerçek bir tarayıcı form-submit'i kullanılıyor (fetch/iframe DEĞİL) - bkz. fetchData.
  const paymentFormRef = useRef(null);
  const orderIdRef = useRef(null);
  const cardNumberRef = useRef(null);
  const expireMonthRef = useRef(null);
  const expireYearRef = useRef(null);
  const cvvRef = useRef(null);
  const cardHolderNameRef = useRef(null);

  const currentDate = new Date();
  const formattedDate = `${currentDate.getDate()}.${currentDate.getMonth() + 1}.${currentDate.getFullYear()}`;
  const offer = cart.cartItems.find(({ priceShow, advertisementShow }) => priceShow === false && advertisementShow === false);

  useEffect(() => {
    if (!cart.shippingAddress?.address) {
      navigate('/shipping');
    } else if (!cart.paymentMethod) {
      navigate('/payment');
    }
  }, [cart.paymentMethod, cart.shippingAddress?.address, navigate]);

  const documentContent = (
    <div style={{ fontSize: '0.85rem', lineHeight: '1.6', color: '#333' }}>
      <h4 className="text-center fw-bold mb-4" style={{ color: '#004488' }}>MESAFELİ SATIŞ SÖZLEŞMESİ</h4>

      <section className="mb-3">
        <h6 className="fw-bold border-bottom pb-1">MADDE 1 - TARAFLAR</h6>
        <p>İşbu Mesafeli Satış Sözleşmesi ("Sözleşme"), aşağıda bilgileri yer alan SATICI ile ALICI arasında, ALICI'nın SATICI'ya ait internet sitesi üzerinden elektronik ortamda verdiği sipariş kapsamında, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri uyarınca akdedilmiştir.</p>
        <div className="ps-2 small mt-2">
          <div className="fw-bold" style={{ color: '#004488' }}>1.1. SATICI</div>
          <div><strong>Ünvan:</strong> ADP ENDÜSTRİYEL OTOMASYON SİSTEMLERİ SAN. VE TİC. LTD. ŞTİ.</div>
          <div><strong>Adres:</strong> Mandıra Cad. Teker Sok. No:2/D Kadıköy/İstanbul</div>
          <div><strong>Telefon:</strong> 0532 494 84 27</div>
          <div><strong>E-Posta:</strong> satis@adpotomasyon.com.tr</div>
        </div>
        <div className="ps-2 small mt-2">
          <div className="fw-bold" style={{ color: '#004488' }}>1.2. ALICI</div>
          <div><strong>Ad Soyad / Ünvan:</strong> {cart.shippingAddress?.companyName} {cart.shippingAddress?.name} {cart.shippingAddress?.surname}</div>
          {cart.shippingAddress?.isCompany === 'true' ? (
            <div><strong>Vergi No / Dairesi:</strong> {cart.shippingAddress?.taxNumber} / {cart.shippingAddress?.taxState}</div>
          ) : (
            <div><strong>T.C. Kimlik No:</strong> {cart.shippingAddress?.idNumber}</div>
          )}
          <div><strong>Adres:</strong> {cart.shippingAddress?.companyAddress}, {cart.shippingAddress?.companyCity} / {cart.shippingAddress?.companyState}</div>
          <div><strong>Telefon:</strong> {cart.shippingAddress?.phoneNumber}</div>
          <div><strong>E-Posta:</strong> {cart.shippingAddress?.email}</div>
        </div>
      </section>

      <section className="mb-3">
        <h6 className="fw-bold border-bottom pb-1">MADDE 2 - SÖZLEŞMENİN KONUSU</h6>
        <p>İşbu Sözleşme'nin konusu; ALICI'nın SATICI'ya ait internet sitesinden elektronik ortamda siparişini verdiği, aşağıda nitelikleri ve satış fiyatı belirtilen ürünün satışı ve teslimi ile ilgili olarak 6502 sayılı Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerinin belirlenmesidir. ALICI, satışa konu ürünün temel nitelikleri, satış fiyatı, ödeme şekli, teslimat koşulları ve SATICI'ya ait diğer bilgiler ile "cayma" hakkını kullanmak için gerekli koşullar hakkında SATICI tarafından siparişi vermeden önce internet sitesinde yer alan ön bilgilendirme formu ile bilgilendirildiğini, bu ön bilgileri elektronik ortamda teyit ettiğini ve sonrasında sipariş verdiğini kabul, beyan ve taahhüt eder.</p>
      </section>

      <section className="mb-3">
        <h6 className="fw-bold border-bottom pb-1">MADDE 3 - SÖZLEŞME KONUSU ÜRÜN, ÖDEME VE TESLİMAT BİLGİLERİ</h6>
        <ListGroup variant='flush' className="border rounded small mb-2">
          {cart.cartItems.map((item, index) => (
            <ListGroup.Item key={index} className="d-flex justify-content-between">
              <span>{item.name} - {item.qty} Adet</span>
              <span className="fw-bold">
                {item.priceShow ? accounting.formatMoney(item.qty * (item.price - (item.price * item.discount / 100)), { symbol: "₺" }) : 'Teklif İstendi'}
              </span>
            </ListGroup.Item>
          ))}
        </ListGroup>
        <div className="bg-light p-2 border rounded small mb-2">
          <div className="d-flex justify-content-between"><span>Ara Toplam:</span> <strong>{!offer ? accounting.formatMoney(cart.itemsPrice * 1, { symbol: "₺" }) : '---'}</strong></div>
          <div className="d-flex justify-content-between"><span>KDV (%20):</span> <strong>{!offer ? accounting.formatMoney(cart.taxPrice * 1, { symbol: "₺" }) : '---'}</strong></div>
          <div className="d-flex justify-content-between border-top pt-1 mt-1"><span className="fw-bold">TOPLAM TUTAR (KDV Dahil):</span> <strong>{offer ? 'Teklif İsteği' : accounting.formatMoney(cart.totalPrice * 1, { symbol: "₺" })}</strong></div>
        </div>
        <div className="bg-light p-2 border rounded small">
          <div><strong>Ödeme Şekli:</strong> {cart.paymentMethod}</div>
          <div><strong>Teslimat Adresi:</strong> {cart.shippingAddress?.address}, {cart.shippingAddress?.city} / {cart.shippingAddress?.state}</div>
          <div><strong>Kargo Firması:</strong> {cart.shippingAddress?.cargoSelection} (Alıcı Ödemeli)</div>
          <div><strong>Teslimat Süresi:</strong> Sipariş onayını ve ödemenin tahsilini takip eden yasal 30 (otuz) günlük süre içinde, stok durumuna göre genellikle daha kısa sürede kargoya teslim edilir.</div>
        </div>
      </section>

      <section className="mb-3">
        <h6 className="fw-bold border-bottom pb-1">MADDE 4 - GENEL HÜKÜMLER</h6>
        <p>4.1. ALICI, Madde 3'te belirtilen sözleşme konusu ürünün temel nitelikleri, satış fiyatı ve ödeme şekli ile teslimata ilişkin tüm ön bilgileri okuyup bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini kabul eder.</p>
        <p>4.2. Sözleşme konusu ürün, yasal 30 günlük süreyi aşmamak koşulu ile her bir ürün için ALICI'nın yerleşim yerinin uzaklığına bağlı olarak internet sitesinde ön bilgiler içinde açıklanan süre içinde ALICI veya gösterdiği adresteki kişi/kuruluşa teslim edilir.</p>
        <p>4.3. SATICI, sözleşme konusu ürünü eksiksiz, siparişte belirtilen niteliklere uygun ve varsa garanti belgeleri, kullanım kılavuzları ile teslim etmeyi kabul ve taahhüt eder.</p>
        <p>4.4. Ürünün teslimatı için işbu Sözleşme'nin elektronik ortamda onaylanmış olması ve bedelinin ALICI'nın tercih ettiği ödeme şekli ile ödenmiş olması şarttır. Herhangi bir nedenle ürün bedeli ödenmez veya banka kayıtlarında iptal edilirse SATICI ürünün teslimi yükümlülüğünden kurtulmuş kabul edilir.</p>
      </section>

      <section className="mb-3">
        <h6 className="fw-bold border-bottom pb-1">MADDE 5 - CAYMA HAKKI</h6>
        <p>ALICI, sözleşme konusu ürünün kendisine veya gösterdiği adresteki kişi/kuruluşa tesliminden itibaren <strong>14 (ondört) gün</strong> içinde herhangi bir gerekçe göstermeksizin ve cezai şart ödemeksizin sözleşmeden cayma hakkına sahiptir. Cayma hakkının kullanılması için bu süre içinde SATICI'ya satis@adpotomasyon.com.tr adresine yazılı bildirimde bulunulması ve ürünün Madde 6'da belirtilen şartlara uygun olması gerekir. Cayma hakkının kullanılması halinde, ALICI'ya yapılan ödemeler, cayma bildiriminin SATICI'ya ulaşmasından itibaren yasal süre içinde ve iade edilen ürünün SATICI'ya ulaşmasını takiben iade edilir. İade kargo bedeli, cayma hakkının usulüne uygun kullanılması halinde SATICI'ya aittir.</p>
      </section>

      <section className="mb-3">
        <h6 className="fw-bold border-bottom pb-1">MADDE 6 - CAYMA HAKKININ KULLANILAMAYACAĞI HALLER</h6>
        <p>Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesi uyarınca; ALICI'nın istekleri veya kişisel ihtiyaçları doğrultusunda hazırlanan (özel ölçü/kesim/montaj gerektiren elektrik-otomasyon malzemeleri dahil), niteliği itibarıyla iade edilmeye elverişli olmayan, tesliminden sonra ambalaj/bant/mühür/paket gibi koruyucu unsurları açılmış ürünlerde ve ilgili mevzuatta sayılan diğer istisnai hallerde ALICI cayma hakkını kullanamaz.</p>
      </section>

      <section className="mb-3">
        <h6 className="fw-bold border-bottom pb-1">MADDE 7 - TEMERRÜT HALİ VE HUKUKİ SONUÇLARI</h6>
        <p>ALICI'nın, kredi kartı ile yaptığı işlemlerde temerrüde düşmesi halinde, kart sahibi banka ile arasındaki kredi kartı sözleşmesi çerçevesinde faiz ödeyeceğini ve bankaya karşı sorumlu olacağını kabul eder. Bu durumda ilgili banka hukuki yollara başvurabilir; doğacak masraf ve vekalet ücretini ALICI'nın ödeyeceğini, ALICI'nın borcu gecikmeli ifasından dolayı SATICI'nın uğrayacağı zarar ve ziyandan ALICI'nın sorumlu olacağını kabul eder.</p>
      </section>

      <section className="mb-3">
        <h6 className="fw-bold border-bottom pb-1">MADDE 8 - YETKİLİ MAHKEME</h6>
        <p>İşbu Sözleşme'nin uygulanmasında, Ticaret Bakanlığınca ilan edilen değere kadar ALICI'nın yerleşim yerindeki Tüketici Hakem Heyetleri ile SATICI veya ALICI'nın yerleşim yerindeki Tüketici Mahkemeleri yetkilidir.</p>
      </section>

      <section className="mb-3">
        <h6 className="fw-bold border-bottom pb-1">MADDE 9 - YÜRÜRLÜK</h6>
        <p>ALICI, Site üzerinden verdiği siparişe ait ödemeyi gerçekleştirdiğinde işbu Sözleşme'nin tüm şartlarını kabul etmiş sayılır. SATICI, siparişin gerçekleşmesi öncesinde işbu Sözleşme'nin sitede ALICI tarafından okunup kabul edildiğine dair onay alacaktır.</p>
        <p className="text-muted small mt-2">Sözleşme Tarihi: {formattedDate}</p>
      </section>
    </div>
  );

  const placeOrderHandler = async () => {
    const timeAdjustedDate = new Date();
    timeAdjustedDate.setHours(timeAdjustedDate.getHours() + 3);
    try {
      setTrig("1");
      const res = await createOrder({
        orderItems: cart.cartItems, shippingAddress: cart.shippingAddress,
        paymentMethod: cart.paymentMethod, itemsPrice: cart.itemsPrice,
        taxPrice: cart.taxPrice, totalPrice: cart.totalPrice,
        offeredAt: timeAdjustedDate, isOffered: !offer,
      }).unwrap();
      navigate(`/placeorder/${res._id}`);
    } catch (err) {
      console.error(err);
      setTrig('');
    }
  };

  // --------------------------------------------------------------------------
  // ÖDEME BAŞLATMA (3D Secure / Kuveyt Türk)
  //
  // Önceki sürümden farklar:
  //   - API şifresi ("api123") ve HashData hesaplama BURADA YAPILMIYOR. Bunlar
  //     tarayıcıda çalıştığı için herkes "view source" ile şifreyi görebilirdi.
  //     Artık backend'de (orderController.js -> initiate3DPayment) hesaplanıyor.
  //   - Kart bilgileri artık createOrder'a (dolayısıyla veritabanına) GÖNDERİLMİYOR;
  //     sadece aşağıdaki gizli form ile doğrudan /api/payment/initiate'e gidiyor.
  //   - Bankadan dönen HTML artık `dangerouslySetInnerHTML` ile sayfa içine
  //     gömülmüyor (React bu şekilde <script> etiketlerini ÇALIŞTIRMAZ, yani
  //     bankanın otomatik yönlendirme script'i hiç tetiklenmiyordu). Bunun yerine
  //     gerçek bir tarayıcı form-submit'i ile TAM SAYFA yönlendirme yapılıyor.
  // --------------------------------------------------------------------------
  const fetchData = async () => {
    try {
      const timeAdjustedDate = new Date();
      timeAdjustedDate.setHours(timeAdjustedDate.getHours() + 3);
      setTrig("1");

      const res = await createOrder({
        orderItems: cart.cartItems,
        shippingAddress: cart.shippingAddress,
        paymentMethod: cart.paymentMethod,
        // NOT: `creditCard` artık gönderilmiyor.
        itemsPrice: cart.itemsPrice,
        taxPrice: cart.taxPrice,
        totalPrice: cart.totalPrice,
        offeredAt: timeAdjustedDate,
        isOffered: true,
      }).unwrap();

      const expiryString = String(cart.creditCard?.expiry);
      const expireMonth = expiryString.slice(0, 2);
      const expireYear = expiryString.slice(-2);

      // Gizli form input'larını doldur (uncontrolled - React state döngüsünü beklemez)
      orderIdRef.current.value = res._id;
      cardNumberRef.current.value = cart.creditCard?.number;
      expireMonthRef.current.value = expireMonth;
      expireYearRef.current.value = expireYear;
      cvvRef.current.value = cart.creditCard?.cvv;
      cardHolderNameRef.current.value = cart.creditCard?.name?.toUpperCase();

      // Gerçek tarayıcı form-submit'i: sayfa, backend'in dönderdiği (bankanın
      // ThreeDModelPayGate'inden gelen) HTML'e TAM SAYFA olarak geçiş yapar.
      paymentFormRef.current.submit();
    } catch (err) {
      console.error(err);
      setTrig('');
    }
  };
  return (
    currency && (
      <div style={{ paddingTop: '10px', paddingBottom: '10px', backgroundColor: '#f8f9fa' }}>
        <Container>
          {userInfo ? <CheckoutStatusBar1 step4 /> : <CheckoutStatusBar userfill step4 />}
          <Row style={{ marginTop: '-20px' }}>
            <Col xs={12} md={8}>
              <Card  className="border-0 shadow-sm rounded-4 overflow-hidden mb-4"
  style={{ 
    borderTop: '4px solid #004488',
    marginTop: '40px',    // Negatif margin ile aradaki dikey beyaz boşluk tamamen kapatıldı
    position: 'relative',
    zIndex: 0
  }}>
                <Card.Header className="text-white p-3 border-0" style={{ backgroundColor: '#66CCFF' }}>
                  <h4 className="m-0 fw-bold fs-5">Sipariş Bilgilerini Teyit Edin</h4>
                </Card.Header>
                <ListGroup variant='flush'>
                  
                  {/* SEVKİYAT VE KARGO TEYİDİ */}
                  <ListGroup.Item className="p-4 border-bottom">
                    <h5 className="fw-bold mb-3 text-dark"><FaTruck className="me-2 text-muted" /> Sevkiyat ve Kargo</h5>
                    <Row>
                      <Col xs={12} sm={7}>
                        <div className="small text-muted mb-1">Teslimat Adresi:</div>
                        <p className="mb-0 fw-bold">{cart.shippingAddress?.receiver}</p>
                        <p className="small mb-0">{cart.shippingAddress?.address}, {cart.shippingAddress?.city} / {cart.shippingAddress?.state}</p>
                      </Col>
                      <Col xs={12} sm={5} className="mt-3 mt-sm-0 border-start ps-4">
                        <div className="small text-muted mb-1">Seçilen Kargo:</div>
                        <div className="d-flex align-items-center gap-2">
                          {cart.shippingAddress?.cargoSelection === 'Yurtiçi Kargo' ? (
                            <img src='/images/yurtici.jpg' height="40" alt="Yurtiçi" />
                          ) : cart.shippingAddress?.cargoSelection === 'Aras Kargo' ? (
                            <img src='/images/aras.jpg' height="40" alt="Aras" />
                          ) : (
                            <img src='/images/mng.jpg' height="40" alt="MNG" />
                          )}
                          <span className="fw-bold small" style={{ color: '#0a5c2b' }}>Ücretsiz Kargo</span>
                        </div>
                      </Col>
                    </Row>
                  </ListGroup.Item>

                  {/* ÖDEME HESAP/KART TEYİDİ */}
                  <ListGroup.Item className="p-4 border-bottom">
                    <h5 className="fw-bold mb-3 text-dark"><FaCreditCard className="me-2 text-muted" /> Ödeme Detayları</h5>
                    <p className="mb-2"><strong>Yöntem:</strong> {cart.paymentMethod}</p>
                    {cart.paymentMethod === "Banka Transferi" ? (
                      <div className="p-3 bg-light border border-secondary-subtle rounded-3 small shadow-inner">
                        <strong className="d-block mb-1" style={{ color: '#004488' }}>ADP ENDÜSTRİYEL OTOMASYON SİSTEMLERİ SAN. VE TİC. LTD. ŞTİ.</strong>
                        <div>Kuveyt Türk - TR82 0020 5000 0977 1989 0000 02</div>
                      </div>
                    ) : cart.paymentMethod === "Kredi Kartı" && !offer && (
                      <div className="bg-light p-3 border rounded d-inline-block">
                        <div className="small text-muted mb-1">Ödeme Yapılacak Kart:</div>
                        <div className="fw-bold font-monospace">**** **** **** {String(cart.creditCard?.number).slice(-4)}</div>
                        <div className="small text-uppercase">{cart.creditCard?.name}</div>
                      </div>
                    )}
                  </ListGroup.Item>
                  {/* ÜRÜN LİSTESİ VE KALEM BAZLI FİYATLAR */}
                  <ListGroup.Item className="p-4">
                    <h5 className="fw-bold mb-3 text-dark">Ürün Listesi</h5>
                    <ListGroup variant='flush' className="border rounded-3">
                      {cart.cartItems.map((item, index) => (
                        <ListGroup.Item key={index} className="py-3">
                          <Row className="align-items-center">
                            <Col xs={2} sm={1}><Image src={item.image} alt={item.name} fluid rounded className="border p-1 bg-white" /></Col>
                            <Col xs={10} sm={6}>
                              <span className="fw-bold text-dark small d-block">{item.name}</span>
                            </Col>
                            <Col xs={12} sm={5} className="text-sm-end fw-bold font-monospace text-secondary" style={{ fontSize: '0.85rem' }}>
                              {item.priceShow || item.advertisementShow ? (
                                <>
                                  {item.discount > 0 && (
                                    <div style={{ textDecoration: 'line-through', color: '#999', fontWeight: 'normal', fontSize: '0.75rem' }}>
                                      {accounting.formatMoney(item.price, { symbol: "₺" })}
                                    </div>
                                  )}
                                  {item.qty} x {accounting.formatMoney(item.price - (item.price * item.discount / 100), { symbol: "₺" })} = {accounting.formatMoney(item.qty * (item.price - (item.price * item.discount / 100)), { symbol: "₺" })}
                                </>
                              ) : (
                                <span className="badge bg-warning text-dark">Teklif Verilecek</span>
                              )}
                            </Col>
                          </Row>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>

            {/* SAĞ KOLON: ÖZET VE ONAY BUTONU */}
            <Col xs={12} md={4} className="mt-4 mt-md-0">
              <Card  className="border-0 shadow-sm rounded-4 overflow-hidden mb-4" 
  style={{ 
    borderTop: '4px solid #004488',
    marginTop: '40px',    // Negatif margin ile aradaki dikey beyaz boşluk tamamen kapatıldı
    position: 'relative',
    zIndex: 0
  }}>
                <Card.Header className="bg-dark text-white p-3 border-0"><h5 className="m-0 fw-bold">Sipariş Özeti</h5></Card.Header>
                <ListGroup variant='flush'>
                  <ListGroup.Item className="p-3">
                    <div className="d-flex justify-content-between mb-1 small"><span>Ara Toplam:</span> <strong>{!offer ? accounting.formatMoney(cart.itemsPrice * 1, { symbol: "₺" }) : '---'}</strong></div>
                    <div className="d-flex justify-content-between mb-2 small"><span>KDV (%20):</span> <strong>{!offer ? accounting.formatMoney(cart.taxPrice * 1, { symbol: "₺" }) : '---'}</strong></div>
                    <hr className="my-2" />
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <span className="fw-bold">Toplam:</span>
                      <span className="text-primary fw-bold fs-5">{offer ? 'Teklif İsteği' : accounting.formatMoney(cart.totalPrice * 1, { symbol: "₺" })}</span>
                    </div>
                  </ListGroup.Item>

                  <ListGroup.Item className="p-3 bg-light border-0">
                    <div className="d-flex flex-column gap-2">
                      <div className="d-flex align-items-center gap-2 p-2 bg-white rounded border mb-1 small">
                        <Form.Check type="checkbox" checked={isConfirm} disabled={!isEnable} onChange={(e) => setIsConfirm(e.target.checked)} />
                        <span onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer', color: '#004488', textDecoration: 'underline' }}>Sözleşmeyi</span> onaylıyorum.
                      </div>
                      <Button
                        className='w-100 border-0 fw-bold'
                        disabled={!isConfirm || trig === "1"}
                        onClick={cart.paymentMethod === "Kredi Kartı" ? fetchData : placeOrderHandler}
                        style={{ backgroundColor: !isConfirm ? '#aaa' : '#2b2b2b', color: '#fff', height: '46px', borderRadius: '4px' }}
                        onMouseEnter={(e) => { if (isConfirm) e.target.style.backgroundColor = '#66CCFF'; }}
                        onMouseLeave={(e) => { if (isConfirm) e.target.style.backgroundColor = '#2b2b2b'; }}
                      >
                        {offer ? 'TEKLİF GÖNDER' : 'SİPARİŞİ TAMAMLA'}
                      </Button>
                    </div>
                    <DocumentModal isOpen={isModalOpen} content={documentContent} onClose={() => { setIsModalOpen(false); setIsEnable(true); }} />
                    {isLoading && <div className="text-center mt-2"><Loader /></div>}
                    {error && <Message variant="danger" className="mt-2">{error?.data?.message || error?.error || 'Sipariş oluşturulamadı.'}</Message>}

                    {/*
                      Bankaya 3D Secure kart doğrulama isteğini gönderen gizli form.
                      Gerçek bir tarayıcı POST'u kullanır (fetch/iframe/dangerouslySetInnerHTML
                      DEĞİL) - bu sayede backend'in döndürdüğü HTML, içindeki otomatik
                      yönlendirme <script>'i dahil, tam sayfa olarak normal şekilde çalışır.
                    */}
                    <form ref={paymentFormRef} method="POST" action="/api/payment/initiate" style={{ display: 'none' }}>
                      <input type="hidden" name="orderId" ref={orderIdRef} />
                      <input type="hidden" name="cardNumber" ref={cardNumberRef} />
                      <input type="hidden" name="expireMonth" ref={expireMonthRef} />
                      <input type="hidden" name="expireYear" ref={expireYearRef} />
                      <input type="hidden" name="cvv" ref={cvvRef} />
                      <input type="hidden" name="cardHolderName" ref={cardHolderNameRef} />
                    </form>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  );
};

export default PlaceOrderScreen;